import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import WebServiceMarkup from '../entities/flight/webServiceMarkup'


interface WebServiceMarkupState extends ListState<WebServiceMarkup> {
    webserviceMarkup: WebServiceMarkup,
    editWebServiceMarkup: WebServiceMarkup,


}

class WebServiceMarkupMutations extends ListMutations<WebServiceMarkup>{

}

class WebServiceMarkupModule extends ListModule<WebServiceMarkupState, any, WebServiceMarkup>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<WebServiceMarkup>(),
        loading: false,
        editWebServiceMarkup: new WebServiceMarkup(),
        selectWebServiceMarkup: new WebServiceMarkup(),


    }
    actions = {



        async addAuxiliaryServiceMarkup(context: ActionContext<WebServiceMarkupState, any>, payload: any) {
            let reponse = await Ajax.post(
                '/api/services/app/Flight/AddAuxiliaryServiceMarkup',
                payload.data
            );

        },

        async saveAuxiliaryServiceMarkup(context: ActionContext<WebServiceMarkupState, any>, payload: any) {
            let reponse = await Ajax.post(
                '/api/services/app/Flight/SaveAuxiliaryServiceMarkup',
                payload.data
            );

        },




        async getAuxiliaryServiceMarkups(context: ActionContext<WebServiceMarkupState, any>, payload: any) {

            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Flight/GetAuxiliaryServiceMarkups', payload.data);
            console.log(reponse);
            context.state.loading = false;
            let page = reponse.data.result as PageResult<WebServiceMarkup>;

            context.state.totalCount = page.totalCount;
            context.state.list = page.items;


        },

        async deleteAuxiliaryServiceMarkup(context: ActionContext<WebServiceMarkupState, any>, payload: any) {
            await Ajax.delete(
                '/api/services/app/Flight/DeleteAuxiliaryServiceMarkup?id=' + payload.payload
            );
        },





    };
    mutations = {
        setCurrentPage(state: WebServiceMarkupState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: WebServiceMarkupState, pagesize: number) {
            state.pageSize = pagesize;
        },

    }
}
const webServiceMarkupModule = new WebServiceMarkupModule();
export default webServiceMarkupModule;